"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalPaymentEventTypes = void 0;
var ExternalPaymentEventTypes;
(function (ExternalPaymentEventTypes) {
    ExternalPaymentEventTypes["INITIAL"] = "INITIAL";
    ExternalPaymentEventTypes["INITIAL_ADDON"] = "INITIAL_ADDON";
    ExternalPaymentEventTypes["HOOK"] = "HOOK";
    ExternalPaymentEventTypes["AUTO_PAYMENT_INIT"] = "AUTO_PAYMENT_INIT";
    ExternalPaymentEventTypes["AUTO_PAYMENT_INIT_ADDON"] = "AUTO_PAYMENT_INIT_ADDON";
    ExternalPaymentEventTypes["AUTO_PAYMENT_CHARGE"] = "AUTO_PAYMENT_CHARGE";
    ExternalPaymentEventTypes["AUTO_PAYMENT_CHARGE_ADDON"] = "AUTO_PAYMENT_CHARGE_ADDON";
    ExternalPaymentEventTypes["AUTO_PAYMENT_EXPIRED_INIT"] = "AUTO_PAYMENT_EXPIRED_INIT";
    ExternalPaymentEventTypes["AUTO_PAYMENT_EXPIRED_CHARGE"] = "AUTO_PAYMENT_EXPIRED_CHARGE";
    ExternalPaymentEventTypes["CHANGE_PLAN_INIT"] = "CHANGE_PLAN_INIT";
    ExternalPaymentEventTypes["CHANGE_PLAN_CHARGE"] = "CHANGE_PLAN_CHARGE";
    ExternalPaymentEventTypes["CHANGE_CARD_INIT"] = "CHANGE_CARD_INIT";
    ExternalPaymentEventTypes["CHANGE_CARD_REFUND_HOOK"] = "CHANGE_CARD_REFUND_HOOK";
})(ExternalPaymentEventTypes || (exports.ExternalPaymentEventTypes = ExternalPaymentEventTypes = {}));
//# sourceMappingURL=external-payment-event-types.enum.js.map